<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>预警管理</el-breadcrumb-item>
        <el-breadcrumb-item>预警记录</el-breadcrumb-item>
      </el-breadcrumb>
      <el-form  :inline="true">
        <el-form-item label="搜索：">
				<el-popover  v-model="visible">
                    <!-- <el-tooltip content="" placement=""> -->
					<el-input class="cp" readonly slot="reference" style="width: 200px;" autosize size="small" value="" placeholder="选择部门/集中器" v-model="getJZ"></el-input>
					<!-- </el-tooltip> -->
					<el-tree :data="deptData"  :expand-on-click-node="false" :highlight-current="true"  @node-click="handleNodeClick"  :props="jzProps"  accordion  node-key='id'>
						<span class="custom-tree-node" slot-scope="{  data }">
							<span>
								<i v-if="!data.parentId && !data.isJz"  class="el-icon-office-building"></i>
								<i v-if="data.parentId"  class="el-icon-location-outline"></i>
								<i v-if="data.isJz"  class="el-icon-coin"></i>
								{{ data.departmentName }}
							</span>
						</span>
					</el-tree>
				</el-popover>
            </el-form-item>
            <el-form-item label="">
               <el-input v-model="tableParam.meterPoint" size="small" placeholder="计量点地址" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
               <el-input v-model="tableParam.meterPointName" size="small" placeholder="计量点名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
               <el-input v-model="tableParam.groupName" size="small" placeholder="群聊名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-select size="small" v-model="tableParam.isSuccess" placeholder="选择类型" style="width: 100px;" clearable>
                    <el-option v-for="item in isSuccessList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                 </el-select>
            </el-form-item>
            <el-form-item label="" prop="pushDate">
                <el-date-picker  size="small" value-format="yyyy-MM-dd" v-model="tableParam.pushDate" type="date" placeholder="选择推送日期"  style="width: 150px;"> </el-date-picker>
            </el-form-item>
            <el-form-item label="">
                <el-button @click="search" type="primary"  icon="el-icon-search" size="small">搜索</el-button>
                <!-- <el-button @click="handleExportRecord" :loading="downloadLoadin" type="success"  icon="el-icon-download" size="small">导出</el-button> -->
                <prems-button size="small" type="success" :loading="downloadLoadin" perms="alarm:alarmRecordExport" icon="el-icon-download" @click="handleExportRecord" label="导出" />
            </el-form-item>
        </el-form>
        <el-table size="small" :data="dataList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
            style="width: 100%;" stripe :max-height="tableHeight"  :header-cell-style="this.$store.state.headerCss">
            <el-table-column align="center" type="index" width="60" label="序号">
            </el-table-column>
            <el-table-column prop="alarmName" label="预警名称" sortable align="center">
            </el-table-column>
            <el-table-column prop="threshold" label="预警阀值" sortable align="center">
            </el-table-column>
            <el-table-column prop="energyValue" label="能耗" sortable align="center">
            </el-table-column>
            <el-table-column prop="groupName" label="群聊名称" sortable align="center">
            </el-table-column>
            <el-table-column prop="meterPointName" label="计量点名称" sortable align="center">
                <!-- <template slot-scope="scope">
               <div v-for="item in scope.row.meterPointName.split('、')" :key="item">
                <el-tag type="primary">{{item}}</el-tag>
               </div>
              </template> -->
            </el-table-column>
            <el-table-column prop="meterPoint" label="计量点地址" sortable align="center">
            </el-table-column>
            <el-table-column prop="terminalCode" label="终端编码" sortable align="center">
            </el-table-column>
            <el-table-column prop="isSuccess" label="推送" sortable align="center">
                  <template slot-scope="scope">
                    <el-tag size="small" type="success" v-if="scope.row.isSuccess">成功</el-tag>
                    <el-tag size="small" type="danger" v-if="!scope.row.isSuccess">失败</el-tag>
              </template>
            </el-table-column>
          </el-table>
          <Pagination v-bind:child-msg="tableParam" @callFather="handelPage" v-if="showPage"></Pagination>
    </div>       
    </template>
<script>
  import { getDepartmentTerminalInfoLis,getTerminalInfoByDepId, } from '../../api/energyMG'
  import { list_alarm_details,exportAlarmDetails } from '../../api/alarmManager'
  import { timestampToTime} from '@/utils/util'
  import Pagination from '../../components/Pagination'
  import PremsButton from "@/views/permission/PreButtom";
  export default{
       data(){
         return{
            deptData:[],
            visible:false,
            jzProps:{
			    label: function( data,node ){
		        },
			    children: 'deps',
		    },
            getJZ:'',
            tableParam:{
                departmentId:'',
                meterPoint:'',
                meterPointName:'',
                isSuccess:'',
                pushDate:'',//推送数据日期
                groupName:'',
                currentPage:1,
                pageSize:10,
                total:0,

            },
            downloadLoadin:false,
            dataList:[],
            showPage:true,
            loading : false,
            tableHeight:0,
            isSuccessList:[
                {label:'全部',value: ''},
                {label:'是',value: 1},
                {label:'否',value: 0},
            ]

         }
        },
        components: {
         Pagination,
         PremsButton
       },
        created(){
            let today = new Date();
            let preDay = today.getTime() - 24 * 60 * 60 * 1000
            console.log('preDay',timestampToTime(preDay))
            this.tableParam.pushDate =  (timestampToTime(preDay).substring(0,10))
            this.getJzData();
        },
        mounted() {
         this.$nextTick(() => {
           this.tableHeight = window.innerHeight - 360
         })
       },
        methods:{
            // 2023.11.21 查询
            search(){
                this.tableParam.currentPage = 1
                this.showPage = false;
                this.getTableData()
                this.$nextTick(()=>{
                    this.showPage = true;
                })
            },
            // 2023.11.21 获取表格数据
            getTableData(){
                this.loading  = true;
                list_alarm_details(this.tableParam).then(res=>{
                    this.loading = false;
                    if(res.status == 1){
                        this.dataList = res.data.content;
                        this.tableParam.total = res.data.totalElements
                    }else{
                        this.$message.info(res.msg)
                    }

                })

            },
              //2023.11.21获取集中器信息
			getJzData:function(){
				return new Promise((resolve,reject) => {
                    this.loading = true;
					getDepartmentTerminalInfoLis().then(res => {
                       
						if(res.status == 1){
							// let arr = []
							this.deptData = this.changeData(res.data.menuDepList)
                            // this.qfFrom.departmentId = this.deptData[0].id;
                            this.tableParam.departmentId = this.deptData[0].id
                            this.getJZ = this.deptData[0].departmentName
							this.getDepIds(JSON.parse(sessionStorage.getItem('userdata')).departmentId);
                            this.getTableData();
							resolve()
						}
						else{
							this.$message.error(res.msg)
						}
					})
				})

			},
            // 2023.11.20 集中器获取
            getDepIds(id){
        getTerminalInfoByDepId({depId:id}).then(res => {
        	if(res.status == 1){
        		let arr = []
        		res.data.forEach( item => {
        			let obj = {}
        			obj.id = item
        			arr.push(obj)
        		})

        		// this.formInline.terIds = JSON.stringify(arr)

        	}else{
        		this.$message.error(res.msg)
        	}
        })
      },
    //   2023.11.20 部门数据处理
      changeData( data ){
				data.forEach(item =>{
					if( item.terminalInfo){
						if(!item.deps){
							item.deps = []
						}
						item.terminalInfo.forEach(sitem => {
							let obj = {}
							obj.id = sitem.id
							obj.departmentName = sitem.terminalName
							obj.terminalCode = sitem.terminalCode
							obj.isJz= true
							item.deps.push(obj)
						})
					}

					if( item.deps){
						this.changeData(item.deps)
					}
				})

				return  data
			},
            // 选择部门
            handleNodeClick(data){
                console.log('data',data)
                this.visible = false
                this.getJZ = data.departmentName
                // this.qfFrom.departmentId = data.id;
                this.tableParam.departmentId = data.id
                this.getTableData();
                if(data.isJz){
                    let idstr = JSON.stringify([{id:data.id}])
                    // this.formInline.terIds = idstr
                // this.search()
                }else{
                    //点击部门获得集中器id
                    this.getDepIds(data.id);
                }
            },
            // 2023.11.21 导出
            handleExportRecord(){
                this.downloadLoadin = true
       
				exportAlarmDetails(this.tableParam).then(res => {

					var blob = new Blob([res], {type: 'application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8'}); //type这里表示xlsx类型
					var downloadElement = document.createElement('a');
				　　var href = window.URL.createObjectURL(blob); //创建下载的链接
				　　downloadElement.href = href;
				　　downloadElement.download = '预警记录.xls'; //下载后文件名
				　　document.body.appendChild(downloadElement);
				　　downloadElement.click(); //点击下载
				　　document.body.removeChild(downloadElement); //下载完成移除元素
				　　window.URL.revokeObjectURL(href); //释放掉blob对象

					this.downloadLoadin = false

				}).catch(err => {
					this.downloadLoadin = false
					this.$message({
						message:'下载失败！',
						type:'error',
						showClose:true
					})
				})

            },
            // 2023.11.21 分页
            handelPage(param){
                this.tableParam.currentPage = param.currentPage;
                this.tableParam.pageSize = param.pageSize;
                this.getTableData();
            }

        }
    }

</script>


// WEBPACK FOOTER //
// src/views/alarmManager/alarmRecorde.vue